module.exports = __webpack_public_path__ + "static/media/icon-plus.40af3a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-plus.svg
// module id = 337
// module chunks = 0